// hooks/useLegalLinkHandler.ts
import { useEffect } from "react";
import { useModal } from "./useModalContext";

export const useLegalLinkHandler = (ref: React.RefObject<HTMLElement>) => {
    const { setModal } = useModal();

    useEffect(() => {
        const container = ref.current;
        if (!container) return;

        const handleClick = (e: MouseEvent) => {
            const target = e.target as HTMLElement;

            if (target.tagName.toLowerCase() === "a") {
                const href = target.getAttribute("href");
                if (!href) return;

                if (href.startsWith("/privacy-policy")) {
                    e.preventDefault();
                    setModal({ active: true, content: "privacy" });
                } else if (href.startsWith("/terms-and-conditions")) {
                    e.preventDefault();
                    setModal({ active: true, content: "terms" });
                }
            }
        };

        container.addEventListener("click", handleClick);
        return () => container.removeEventListener("click", handleClick);
    }, [ref, setModal]);
};
